<template>
  <div class="book-reading-nav">
    <div class="book-reading-nav__container">
      <router-link
        v-if="doc.prevLink.exists"
        replace
        :to="doc.prevLink.params"
        class="book-reading-nav__prev-box"
      >
        <div class="book-reading-nav__link">
          <span class="book-reading-nav__icon iconfont iprev"></span>Previous
        </div>
        <p class="book-reading-nav__name book-reading-nav__prev-name">
          {{ doc.prevLink.title }}
        </p>
      </router-link>
      <router-link
        v-else
        replace
        :to="doc.previewLink.params"
        class="book-reading-nav__prev-box"
      >
        <div class="book-reading-nav__link">
          <span class="book-reading-nav__icon iconfont iprev"></span>Back
        </div>
        <p class="book-reading-nav__name book-reading-nav__prev-name">
          Back to Preview page
        </p>
      </router-link>
    </div>

    <div class="book-reading-nav__container">
      <router-link
        v-if="doc.nextLink.exists"
        replace
        :to="doc.nextLink.params"
        class="book-reading-nav__next-box"
      >
        <div class="book-reading-nav__link book-reading-nav__next">
          Next<span class="book-reading-nav__icon iconfont inext"></span>
        </div>
        <p class="book-reading-nav__name book-reading-nav__next-name">
          {{ doc.nextLink.title }}
        </p>
      </router-link>
      <a v-else class="book-reading-nav__next-box" @click="doc.doneClick()">
        <div class="book-reading-nav__link book-reading-nav__next">
          Done<span class="book-reading-nav__icon iconfont inext"></span>
        </div>
        <p class="book-reading-nav__name book-reading-nav__next-name">
          {{ doc.doneText }}
        </p>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DocView } from '@/models/doc'

defineProps<{
  doc: DocView
}>()
</script>
